<template>
  <div class="container-fluid">
    <!-- Estado de carga -->
    <div v-if="loading" class="text-center py-5">
      <div class="loader-box">
        <div class="loader-3"></div>
      </div>
      <p>Cargando...</p>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="text-center py-5">
      <div class="alert alert-danger">
        <h5>Error al cargar los datos</h5>
        <p>{{ error.message || 'Ocurrió un error inesperado' }}</p>
        <button class="btn btn-primary" @click="bienvenida()">Reintentar</button>
      </div>
    </div>

    <!-- Contenido cuando hay datos -->
    <div v-else-if="welcome != null">
      <div class="page-title">
        <div class="row">
          <div class="col-12">
            <h3>Oportunidades para incorporarte a la cadena de valor verde</h3>
          </div>
          <div class="col-6">
            <ol class="breadcrumb"></ol>
          </div>
        </div>
      </div>      

      <!-- Título y buscador -->
      <div class="col-sm-12 mb-3">
          <div class="card">
            
            <div class="card-body">
              <!-- Buscador -->
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control me-2"
                  placeholder="Describe el tipo de servicio que buscas..."
                  v-model="searchQuery"
                />
                <button class="btn btn-primary" @click="buscar()">
                  <i class="fa fa-search"></i> Buscar
                </button>
              </div>
              
              <!-- Filtros por sector -->
              <div class="mt-3">
                <span class="me-2 fw-bold">Sectores:</span>
                <button 
                  class="btn me-1 mb-1"
                  :class="sectorActivo === 'Agroalimentario' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="filtrarPorSector('Agroalimentario')"
                >
                  Agroalimentario
                </button>
                <button 
                  class="btn me-1 mb-1"
                  :class="sectorActivo === 'Automotriz-Metalúrgico' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="filtrarPorSector('Automotriz-Metalúrgico')"
                >
                  Automotriz-Metalúrgico
                </button>
                <button 
                  class="btn me-1 mb-1"
                  :class="sectorActivo === 'Electrónicos' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="filtrarPorSector('Electrónicos')"
                >
                  Electrónicos
                </button>
                <button 
                  class="btn me-1 mb-1"
                  :class="sectorActivo === 'Mineria' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="filtrarPorSector('Mineria')"
                >
                  Minería
                </button>
                <button 
                  class="btn me-1 mb-1"
                  :class="sectorActivo === 'Textil' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="filtrarPorSector('Textil')"
                >
                  Textil
                </button>
                <button 
                  class="btn me-1 mb-1"
                  :class="sectorActivo === 'Turístico' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="filtrarPorSector('Turístico')"
                >
                  Turístico
                </button>
                <button 
                  v-if="sectorActivo"
                  class="btn btn-outline-secondary mb-1"
                  @click="filtrarPorSector(null)"
                >
                  <i class="fa fa-times"></i> Limpiar
                </button>
              </div>
          </div>
        </div>
      </div>
      

      <div class="row starter-main">

        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-header">
              <small style="color:#fff; font-size:0.75rem;">Empresa verde</small>
            </div>
            <div class="card-body p-0" style="overflow: hidden;">
              <a :href="card1Link" target="blank">
                <img :src="ecobanner"
                  class="img-fluid w-100"
                  style="height: 200px; object-fit: cover; display: block;"
                  alt="multicolor background"
                />
              </a>
            </div>
            <div class="card-footer">
              <p class="mb-2">Especialistas en gestión y administración de proyectos con enfoque sostenible</p>
              <div class="text-end">
                <router-link :to="{ name: 'detalleServicio', params: { id: 1 } }" class="btn btn-outline-primary btn-sm">
                  <i class="fa fa-user"></i> Ver perfil
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-header">
              <small style="color:#fff; font-size:0.75rem;">Empresa verde</small>
            </div>
            <div class="card-body p-0" style="overflow: hidden;">
              <a :href="card1Link" target="blank">
                <img src="https://static.wixstatic.com/media/b9cef4_f23d3aa4b0014456acf4b8a9a92c322e~mv2.jpg/v1/fill/w_568,h_406,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/b9cef4_f23d3aa4b0014456acf4b8a9a92c322e~mv2.jpg"
                  class="img-fluid w-100"
                  style="height: 200px; object-fit: cover; display: block;"
                  alt="multicolor background"
                />
              </a>
            </div>
            <div class="card-footer">
              <p class="mb-2">Especialistas en gestión y administración de proyectos con enfoque sostenible</p>
              <div class="text-end">
                <router-link :to="{ name: 'detalleServicio', params: { id: 2 } }" class="btn btn-primary btn-sm">
                  <i class="fa fa-user"></i> Ver perfil
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-header">
              <small style="color:#fff; font-size:0.75rem;">Empresa verde</small>
            </div>
            <div class="card-body p-0" style="overflow: hidden;">
              <a :href="card1Link" target="blank">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpFhitTn3reriXpnoLDqBKOuHlm5oSEDIehg&s"
                  class="img-fluid w-100"
                  style="height: 200px; object-fit: cover; display: block;"
                  alt="multicolor background"
                />
              </a>
            </div>
            <div class="card-footer">
              <p class="mb-2">Especialistas en gestión y administración de proyectos con enfoque sostenible</p>
              <div class="text-end">
                <router-link :to="{ name: 'detalleServicio', params: { id: 3 } }" class="btn btn-outline-primary btn-sm">
                  <i class="fa fa-user"></i> Ver perfil
                </router-link>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row starter-main">

        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-header">
              <small style="color:#fff; font-size:0.75rem;">Empresa verde</small>
            </div>
            <div class="card-body p-0" style="overflow: hidden;">
              <a :href="card1Link" target="blank">
                <img src="https://assets.aboutamazon.com/dims4/default/735b13e/2147483647/strip/true/crop/1800x1098+0+0/resize/1218x743!/quality/90/?url=https%3A%2F%2Famazon-blogs-brightspot.s3.amazonaws.com%2Fe3%2Fbd%2F430a14ba407db33519391e9ae053%2Frenewableenergy-gallery-2-1800x1098.jpg"
                  class="img-fluid w-100"
                  style="height: 200px; object-fit: cover; display: block;"
                  alt="multicolor background"
                />
              </a>
            </div>
            <div class="card-footer">
              <p class="mb-2">Especialistas en gestión y administración de proyectos con enfoque sostenible</p>
              <div class="text-end">
                <router-link :to="{ name: 'detalleServicio', params: { id: 4 } }" class="btn btn-outline-primary btn-sm">
                  <i class="fa fa-user"></i> Ver perfil
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-header">
              <small style="color:#fff; font-size:0.75rem;">Empresa verde</small>
            </div>
            <div class="card-body p-0" style="overflow: hidden;">
              <a :href="card1Link" target="blank">
                <img src="https://cms-resources.groww.in/uploads/TAX_SLAB_2025_05_22_T155255_666_11zon_038ad180a3.jpg"
                  class="img-fluid w-100"
                  style="height: 200px; object-fit: cover; display: block;"
                  alt="multicolor background"
                />
              </a>
            </div>
            <div class="card-footer">
              <p class="mb-2">Especialistas en gestión y administración de proyectos con enfoque sostenible</p>
              <div class="text-end">
                <router-link :to="{ name: 'detalleServicio', params: { id: 5 } }" class="btn btn-outline-primary btn-sm">
                  <i class="fa fa-user"></i> Ver perfil
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-header">
              <small style="color:#fff; font-size:0.75rem;">Empresa verde</small>
            </div>
            <div class="card-body p-0" style="overflow: hidden;">
              <a :href="card1Link" target="blank">
                <img src="https://teknochem.com.tr/wp-content/uploads/2023/11/teknochem-atik-su-aritma-dizayn-1.jpeg"
                  class="img-fluid w-100"
                  style="height: 200px; object-fit: cover; display: block;"
                  alt="multicolor background"
                />
              </a>
            </div>
            <div class="card-footer">
              <p class="mb-2">Especialistas en gestión y administración de proyectos con enfoque sostenible</p>
              <div class="text-end">
                <router-link :to="{ name: 'detalleServicio', params: { id: 6 } }" class="btn btn-outline-primary btn-sm">
                  <i class="fa fa-user"></i> Ver perfil
                </router-link>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import ecobanner from "@/assets/images/verde/ecobanner.webp";

export default {
  name: "defaultPage",
  data() {
    return {
      ecobanner,
      user: null,
      welcome: null,
      error: null,
      token: null,
      loading: true,
      searchQuery: "",
      sectorActivo: null,
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("userData"));
    this.token = localStorage.getItem("token");
    this.bienvenida();
    console.log("user from home page", this.user?.isAdmin);
    console.log("user from home page", this.user);
  },
  mounted() {},
  methods: {
    filtrarPorSector(sector) {
      this.sectorActivo = sector;
      console.log("Filtrar por sector:", sector);
      // Aquí puedes agregar la lógica de filtrado
    },
    buscar() {
      console.log("Buscar:", this.searchQuery, "Sector:", this.sectorActivo);
      // Aquí puedes agregar la lógica de búsqueda
    },
    async bienvenida() {
      this.loading = true;
      this.error = null;
      try {
        const response = await axios.get(`https://rverdeadmin.klatus.systems/api/v2/blog?fields=intro,body,thumbnail,footer&search=Sobre`);
        this.welcome = response.data;        
      } catch (err) {
        this.error = err;
        console.log("error in bienvenida", err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
